import { Box, Button, Grid, TextField } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";

export default function BioChemistryTestForm({ defaultValues, onSubmit }) {
  const { register, handleSubmit } = useForm({ defaultValues: defaultValues || {} });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Sugar (F)" size="small" variant="outlined" name="sugarF" type="number" {...register('sugarF')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Sugar (PP)" size="small" variant="outlined" name="sugarPP" type="number" {...register('sugarPP')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Sugar (R)" size="small" variant="outlined" name="sugarR" type="number" {...register('sugarR')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="S. Creatinine" size="small" variant="outlined" name="screatinine" type="number" {...register('screatinine')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Urea" size="small" variant="outlined" name="urea" type="number" {...register('urea')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Uric Acid" size="small" variant="outlined" name="uricAcid" type="number" {...register('uricAcid')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Calcium" size="small" variant="outlined" name="calcium" type="number" {...register('calcium')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Amylase" size="small" variant="outlined" name="amylase" type="number" {...register('amylase')} InputLabelProps={{ shrink: true }} inputProps={{ step: "any" }} fullWidth />
        </Grid>
      </Grid>
      <Box mt={2}>
        <Button type="submit" variant="contained" color="primary" size="small">सुरक्षित गर्नुहोस्</Button>
      </Box>
    </form>
  );
}
